import { Box } from '@mui/material';
import { Loader } from 'components';
import { injectIntl } from 'react-intl';
import { ComonUtils } from 'services/comon';
import { SubjectUtils } from 'services/subject';
import { VolunteerActioner } from 'services/volunteer';
import { VolunteerForm } from './VolunteerForm';

function VolunteerCreateComponent({ intl, ...props }) {
  function createForm(templates, subjects, values = {}) {
    return <VolunteerForm templates={templates} subjects={subjects} values={values} mode={'create'} />;
  }

  function renderCreateForm(render) {
    const promises = [ComonUtils.getComonTemplates()];
    promises.push(SubjectUtils.getSubjectTemplates());
    if (props.location.state?.duplicate) {
      promises.push(VolunteerActioner.get(props.location.state.id));
    }
    Promise.all(promises).then(([templates, subjects, values]) => {
      if (values === undefined) {
        render(createForm(templates, subjects));
      } else {
        render(createForm(templates, subjects, values));
      }
    });
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" className="full-width">
      <h2>{intl.messages.scenes.volunteer.create.title}</h2>
      <Loader render={renderCreateForm} />
    </Box>
  );
}

const VolunteerCreate = injectIntl(VolunteerCreateComponent);

export { VolunteerCreate };
